import { BoostProps } from "./boost-check";
import { BoostCode } from "common/boosts";

export const boostList: readonly BoostProps[] = [
    {
        name: "+500 Rows",
        price: "$5 per month",
        color: "#00C781",
        sku: BoostCode.FiveHundredRows,
    },
    {
        name: "+1,000 Rows",
        price: "$10 per month",
        color: "#00C781",
        sku: BoostCode.OneKiloRows,
    },
    {
        name: "+2,500 Rows",
        price: "$20 per month",
        color: "#00C781",
        sku: BoostCode.TwoKiloFiveRows,
    },
    {
        name: "+1,000 Sheet Edits",
        price: "$10 per month",
        color: "#00C781",
        sku: BoostCode.OneKiloReads,
    },
];
